<details>
  <summary class="flex flex-row space-between items-center cursor-pointer">
    <ng-content select="[heading]"></ng-content>
    <nav class="flex flex-row items-center ml-auto mr-0">
      <span class="text-primary text-sm font-bold ml-5 mr-1">
          {{ label }}
      </span>
      <svg-icon src="assets/general/img/arrow-up.svg"></svg-icon>
    </nav>
  </summary>

  <ng-content></ng-content>
</details>
